import { type Market } from "@dotcom/markets";

const localizeDate = (date: Date, market: Market) => {
  const day = String(date.getDate());
  const month = String(date.getMonth() + 1);
  const year = String(date.getFullYear());

  return market.dateFormat
    .split(".")
    .map((part) => {
      switch (part) {
        case "DD": {
          return day.length === 1 ? `0${day}` : day;
        }

        case "MM": {
          return month.length === 1 ? `0${month}` : month;
        }

        case "YYYY": {
          return year;
        }

        default: {
          return "";
        }
      }
    })
    .join(".");
};

export default localizeDate;
